import { graphql } from '../../gql';

export const GET_SELLER_QUERY = graphql(`
  query GetSeller {
    seller {
      id
      idAlias
      firstName
      lastName
      handle
      displayName
      about
      storeTitle
      ownerName
      bio
      headline
      tagline
      story
      notification
      coverImage {
        height
        width
        url
      }
      profileImage {
        height
        width
        url
      }
      logo {
        height
        width
        url
      }
      address {
        address1
        address2
        city
        countryCode
        provinceCode
        postCode
      }
      payoutAccount {
        __typename
        ... on PaypalPayoutAccount {
          email
          userId
        }
        ... on StripePayoutAccount {
          accountId
          active
          bankAccount {
            name
            last4Digits
            currency
            countryCode
          }
        }
      }
      companyName
      email
      phone
      status
      createdAt
      updatedAt
    }
  }
`);

export const SET_SELLER_MUTATION = graphql(`
  mutation SetSeller($input: SetSellerInput!) {
    setSeller(input: $input) {
      id
      idAlias
      firstName
      lastName
      handle
      displayName
      about
      storeTitle
      ownerName
      bio
      headline
      tagline
      story
      notification
      coverImage {
        height
        width
        url
      }
      profileImage {
        height
        width
        url
      }
      logo {
        height
        width
        url
      }
      address {
        address1
        address2
        city
        countryCode
        provinceCode
        postCode
      }
      companyName
      email
      phone
      status
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_PAYOUT_ACCOUNT_MUTATION = graphql(`
  mutation DeletePayoutAccount {
    deletePayoutAccount {
      id
      payoutAccount {
        __typename
        ... on PaypalPayoutAccount {
          email
          userId
        }
        ... on StripePayoutAccount {
          accountId
          active
          bankAccount {
            name
            last4Digits
            currency
            countryCode
          }
        }
      }
    }
  }
`);

export const DISPLAYNAME_EXISTS_QUERY = graphql(`
  query DisplayNameExists($displayName: String!) {
    displayNameExists(displayName: $displayName)
  }
`);

export const HANDLE_EXISTS_QUERY = graphql(`
  query HandleExists($handle: String!) {
    handleExists(handle: $handle)
  }
`);

export const GET_PAYOUT_OPTIONS_QUERY = graphql(`
  query GetPayoutOptions {
    payoutOptions {
      paypal
      stripe
    }
  }
`);

export const GET_PAYPAL_ACCOUNT_LINK_QUERY = graphql(`
  query GetPaypalAccountLink {
    paypalAccountLink
  }
`);

export const GET_STRIPE_ACCOUNT_LINK_QUERY = graphql(`
  query GetStripeAccountLink($type: StripeAccountLinkType!) {
    stripeAccountLink(type: $type)
  }
`);
